import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { addCartAction, addCartDialogAction } from '@app/react/action';
import type { AsyncGeneralState } from '@app/react/const/type';
import { makiwaraShipDateAlert } from '@app/react/action/MakiwaraShipDateAlert';
import { fetchInitProductSetItemAction } from '@app/react/action';

export interface ICustomDesignUIReducer {
    initProductSetState: AsyncGeneralState;
    initProductSetArrowType?: null | 'kinteki' | 'enteki' | 'makiwara',
    initProductSetOrderType?: null | 'full' | 'semi',
    cartInState: AsyncGeneralState;
    makiwaraShipDialog: boolean;
}

const initState: ICustomDesignUIReducer = {
    initProductSetState: 'init',
    initProductSetArrowType: undefined,
    initProductSetOrderType: undefined,
    cartInState: 'init',
    makiwaraShipDialog: false,
};

export const customDesignUIReducer = reducerWithInitialState(initState)
    .case(addCartAction.started, (state) => ({
        ...state,
        cartInState: 'request',
    }))
    .case(addCartAction.failed, (state) => ({
        ...state,
        cartInState: 'error',
    }))
    .case(addCartAction.done, (state) => ({
        ...state,
        cartInState: 'done',
    }))
    .case(fetchInitProductSetItemAction.started, (state, action) => {
        if (action.rid) {
            return {
                ...state,
                initProductSetState: 'request',
            };
        }
        return {
            ...state,
            initProductSetState: 'done',
        };
    })
    .case(fetchInitProductSetItemAction.failed, (state) => ({
        ...state,
        initProductSetState: 'error',
    }))
    .case(fetchInitProductSetItemAction.done, (state) => ({
        ...state,
        initProductSetState: 'done',
    }))
    .case(addCartDialogAction, (state, action) => {
        const { show } = action;

        return {
            ...state,
            cartInState: show ? 'done' : 'init',
        };
    })
    .case(makiwaraShipDateAlert, (state, { show }) => ({
        ...state,
        makiwaraShipDialog: show,
    }));
